import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import {FormCategoryDTO } from "../dto/formCategoryDTO";

import { MiProModules } from "@mipro/classes/mipro-modules";
import { Permissions } from "@main/permissions/permissions";
import { DisableDeleteCategories } from "../components/form-categories/disable-delete-categories";


@Injectable()
export class FormIOCategoryService extends PagedCrudService<FormCategoryDTO>{
    public readonly url = "api/formio-category";
    public readonly entityTitle = "Form Category";
    

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    async getAllCategories(): Promise<FormCategoryDTO[]> {
        return await this.handleRequest<FormCategoryDTO[]>(
            this.http.get<FormCategoryDTO[]>(`${this.url}/all`),
            this.handlersFactory.getDefault());
    }


    getWritePermissionsForCategory(categoryName: string): Permissions[] {
        const permissionsMap: { [key: string]: Permissions[] } = {
            [MiProModules.Consultations]: [
                Permissions.ConsultationHistoryPrivateEpisodeWrite,
                Permissions.ConsultationHistoryWrite,
                Permissions.ConsultationHistoryWritePrivateEpisodesUnrestricted
            ],
            [MiProModules.Prescriptions]: [Permissions.WritePrescriptions],
            [MiProModules.Tues]: [],
            [MiProModules.Referrals]: [],
            [MiProModules.Investigations]: [],
            [MiProModules.GlobalDRO]: [],
            [MiProModules.FunctionalGut]: [Permissions.WriteFunctionalGut],
            [MiProModules.Forms]: [Permissions.WriteFormsInstances],
            [MiProModules.Diary]: [Permissions.WriteDiary],
            [MiProModules.Raven]: [Permissions.IRNRead],
            [MiProModules.EventsModule]: [Permissions.WriteIncidents],
            [MiProModules.Reporting]: [],
            [MiProModules.NHS]: [],

            //additional categories
            [DisableDeleteCategories.ConsultationForms]: [],
            [DisableDeleteCategories.Survey]: []
        };
    
        return permissionsMap[categoryName] || null;
    }
}